import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";

@Injectable()
export class WorkflowsService {
  constructor(private http: HttpClientService) {}

  public getMetadataByApp(id, { keys = [] }): Observable<any> {
    const options = { params: { keys } };
    return this.http
      .get(`/api/applications/${  id  }/workflow/metadata`, options)
      .pipe(tap((_) => console.log("WorkflowsService.getMetadataByApp: Ok.")));
  }

  public assignWorkflow(id, user_id, strict = false): Observable<any> {
    const params = {
      user_id,
      strict,
    };
    return this.http
      .post(`/api/workflow/${  id  }/assign`, params)
      .pipe(tap((_) => console.log("WorkflowsService.assignWorkflow: Ok.")));
  }

  public autoAssignWorkflow(): Observable<any> {
    return this.http
      .post("/api/workflow/auto_assign", {})
      .pipe(tap((_) => console.log("WorkflowsService.autoAssignWorkflow: Ok.")));
  }

  public getWorkflows(params): Observable<any> {
    const options = { params };
    return this.http
      .get("/api/workflow/workflows", options)
      .pipe(tap((_) => console.log("WorkflowsService.getWorkflows: Ok.")));
  }

  public getWorkflowsWaitingCount(): Observable<any> {
    return this.http
      .get("/api/workflow/waiting_analyst_count", {})
      .pipe(tap((_) => console.log("WorkflowsService.getWorkflowsWaitingCount : Ok.")));
  }

  public resume({
    start = undefined,
    end = undefined,
    stages = undefined,
    compare = undefined,
    count = undefined,
    group_period = undefined,
    group_by = undefined,
    show = undefined,
    filter_ids = undefined,
  }): Observable<any> {
    const options = {
      params: {
        count,
        start,
        end,
        group_period,
        group_by,
        show,
        "stages[]": stages,
        "compare[]": compare,
        "filter_ids[]": filter_ids,
      },
    };
    return this.http.get("/api/workflow/resume", options).pipe(tap((_) => console.log("WorkflowsService.resume: Ok.")));
  }

  public getIncidents(from, to): Observable<any> {
    const options = {
      params: {
        from,
        to,
      },
    };
    return this.http
      .get("/api/workflow/incidents", options)
      .pipe(tap((_) => console.log("WorkflowsService.getIncidents: Ok.")));
  }

  public getRejections(from, to): Observable<any> {
    const options = {
      params: {
        from,
        to,
      },
    };
    return this.http
      .get("/api/workflow/rejections", options)
      .pipe(tap((_) => console.log("WorkflowsService.getRejections: Ok.")));
  }

  public getRejectionsDetail(from, to): Observable<any> {
    const options = {
      params: {
        from,
        to,
      },
    };
    return this.http
      .get("/api/workflow/rejections_detail", options)
      .pipe(tap((_) => console.log("WorkflowsService.getRejectionsDetail: Ok.")));
  }

  public getAnalystsResume({ from = undefined, to = undefined }): Observable<any> {
    const options = {
      params: {
        from,
        to,
      },
    };
    return this.http
      .get("/api/workflow/analysts_resume", options)
      .pipe(tap((_) => console.log("WorkflowsService.getAnalystsResume: Ok.")));
  }

  public getAnalystsReport({ from = undefined, to = undefined, monthly = true }): Observable<any> {
    const options = {
      params: {
        from,
        to,
        monthly: monthly.toString(),
      },
    };
    return this.http
      .get("/api/workflow/analyst_time_report", options)
      .pipe(tap((_) => console.log("WorkflowsService.getAnalystsReport: Ok.")));
  }

  public update_metadata_by_app(
    application_id: number | string,
    {
      address_for_contract_signature,
      special_indications,
      answered_call,
      calls_history,
      call_start_time,
      call_end_time,
      call_elapsed_time,
      invalid_docs,
      called_when_10m,
      additional_income_docs_counter,
      titular_phone_success_contact,
    }: {
      address_for_contract_signature?: unknown;
      special_indications?: unknown;
      answered_call?: boolean | null;
      calls_history?: unknown[];
      call_start_time?: string;
      call_end_time?: string;
      call_elapsed_time?: string;
      invalid_docs?: unknown;
      called_when_10m?: unknown;
      additional_income_docs_counter?: unknown;
      titular_phone_success_contact?: string | null;
    }
  ) {
    const params = {
      address_for_contract_signature,
      special_indications,
      answered_call,
      calls_history,
      call_start_time,
      call_end_time,
      call_elapsed_time,
      invalid_docs,
      called_when_10m,
      additional_income_docs_counter,
      titular_phone_success_contact,
    };

    return this.http
      .put(`/api/applications/${  application_id  }/workflow/update_metadata`, params)
      .pipe(tap((_) => console.log("WorkflowsService.update_metadata_by_app: Ok.")));
  }

  public update_metadata({
    id,
    address_for_contract_signature = undefined,
    special_indications = undefined,
    answered_call = undefined,
    calls_history = undefined,
    call_start_time = undefined,
    call_end_time = undefined,
    call_elapsed_time = undefined,
    invalid_docs = undefined,
    additional_visit = undefined,
    titular_phone_success_contact = undefined,
  }) {
    const params = {
      address_for_contract_signature,
      special_indications,
      answered_call,
      calls_history,
      call_start_time,
      call_end_time,
      call_elapsed_time,
      invalid_docs,
      additional_visit,
      titular_phone_success_contact,
    };
    return this.http
      .put(`/api/workflow/${  id  }/update_metadata`, params)
      .pipe(tap((_) => console.log("WorkflowsService.update_metadata: Ok.")));
  }

  public update_to_previous_state(id) {
    return this.http
      .put(`/api/workflow/${  id  }/update_to_previous_state`, null)
      .pipe(tap((_) => console.log("WorkflowsService.update_to_previous_state: Ok.")));
  }
}
